import { areFilterGroupsSupported } from 'reporting-data/utils/areFilterGroupsSupported';
import { isConfigReport, isJourneyReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { useContext, useEffect } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { getDataType } from 'reporting-data/report/reportGetters';
import { logMessage } from 'reporting-data/monitoring/logger';
// @ts-expect-error Untyped dependency
import FilterEditor from '../FilterEditor';
export const useShouldShowFiltersBar = (report, condensedFullpageView = false) => {
  const userInfo = useContext(UserInfoContext);
  const filterGroupsSupported = areFilterGroupsSupported(report, userInfo);
  useEffect(() => {
    if (!condensedFullpageView && !filterGroupsSupported && FilterEditor.isUsableForReport(report, {
      readOnly: false
    })) {
      // In case the filter groups are not supported, but the legacy filter editor is usable,
      // Log this case for further investigation.
      const dataType = getDataType(report);
      logMessage({
        message: 'Disabling new filter for a data type',
        extra: {
          dataType,
          report
        }
      });
    }
  }, [condensedFullpageView, filterGroupsSupported, report]);
  if (condensedFullpageView) {
    return {
      showFiltersBar: false,
      showRelationalReportFiltersBar: false,
      showOptInControl: false,
      showJourneyReportFiltersBar: false
    };
  }
  const showFiltersBar = isConfigReport(report) && filterGroupsSupported;
  const showRelationalReportFiltersBar = isRelationalReport(report);
  const showJourneyReportFiltersBar = isJourneyReport(report);
  return {
    showFiltersBar,
    showRelationalReportFiltersBar,
    areFilterGroupsSupported: filterGroupsSupported,
    showJourneyReportFiltersBar
  };
};